/**
 * Request Payload Interfaces
 *
 * There are 2 Smart Order main type :
 * 1. Auto Buy (AB)
 * 2. Auto Sell (AS)
 *   2.1 Take Profit (TP)
 *   2.2 Stop Loss (TS)
 */

import { SmartOrderCode } from '../transaction';

export interface CreateSmartOrderPayload {
  stock_code: string;
  shares: string;
  price: number;
  type: SmartOrderCode;
  config_type?: string; // '1' | '2';
  trigger_price?: number;
  gtc?: string; // '0' | '1'
}

export interface EditSmartOrderPayload {
  id: string;
  shares: string;
  price: number;
  config_type?: string; // '1' | '2';
  trigger_price?: number;
}

export interface DeleteSmartOrderPayload {
  id: string;
}

export interface GetSmartOrderPayload {
  stock_code: string;
}

export interface SaveTNCSmartOrderPayload {
  product: string; // 'AB' | 'AS';
}

/**
 * Response Data Interfaces
 */

export interface CreateSmartOrderResponse {
  message: string;
}

export interface EditSmartOrderResponse {
  message: string;
}

export interface DeleteSmartOrderResponse {
  message: string;
}

export interface SmartOrderResponseItem {
  id: string;
  type_text: string;
  price: number;
  shares: string;
  source: number;
  realized_amount: number;
  realized_percentage: number;
  is_realized_gain_hidden: boolean;
}

export type GetSmartOrderResponse = SmartOrderResponseItem[];

export interface SaveTNCSmartOrderResponse {
  message: string;
}

export enum StopOrderProductCode {
  Unspecified = 'ORDER_PRODUCT_CODE_UNSPECIFIED',
  StopLoss = 'ORDER_PRODUCT_CODE_STOP_LOSS',
  TakeProfit = 'ORDER_PRODUCT_CODE_TAKE_PROFIT',
  LimitIfTouched = 'ORDER_PRODUCT_CODE_LIMIT_IF_TOUCHED',
}

export enum StopOrderAssetType {
  Unspecified = 'ASSET_TYPE_UNSPECIFIED',
  Stock = 'ASSET_TYPE_STOCK_REGULAR',
  Right = 'ASSET_TYPE_STOCK_RIGHT',
  Warrant = 'ASSET_TYPE_STOCK_WARRANT',
  Bond = 'ASSET_TYPE_FR_BOND',
}

export enum StopOrderAssetMarketBoard {
  Unspecified = 'MARKET_BOARD_UNSPECIFIED',
  Reguler = 'MARKET_BOARD_REGULER',
  Tunai = 'MARKET_BOARD_TUNAI',
}

export enum StopOrderTriggerType {
  Unspecified = 'ORDER_TRIGGER_TYPE_UNSPECIFIED',
  LessThanEqual = 'ORDER_TRIGGER_TYPE_LTE',
  GreaterThanEqual = 'ORDER_TRIGGER_TYPE_GTE',
}

export enum StopOrderSide {
  Unspecified = 'ORDER_SIDE_UNSPECIFIED',
  Buy = 'ORDER_SIDE_BUY',
  Sell = 'ORDER_SIDE_SELL',
}

export enum StopOrderOrderType {
  Unspecified = 'ORDER_TYPE_UNSPECIFIED',
  Limit = 'ORDER_TYPE_LIMIT',
  Market = 'ORDER_TYPE_MARKET',
}

export enum StopOrderExpiryType {
  Unspecified = 'ORDER_EXPIRY_TYPE_UNSPECIFIED',
  GFD = 'ORDER_EXPIRY_TYPE_GFD',
  GTC = 'ORDER_EXPIRY_TYPE_GTC',
  Market = 'ORDER_EXPIRY_TYPE_FAK',
}

export interface ReqCreateStopOrder {
  product_code: StopOrderProductCode;
  asset: {
    code: string;
    type: StopOrderAssetType;
    market_board: StopOrderAssetMarketBoard;
  };
  shares: string;
  trigger_type: StopOrderTriggerType;
  trigger_price: string;
  order_side: StopOrderSide;
  order_price?: string;
  order_type: StopOrderOrderType;
  order_expiry_type: StopOrderExpiryType;
}

export interface ReqAmendStopOrder {
  new_price?: string;
  new_shares?: string;
  new_order_type?: StopOrderOrderType;
  new_order_expiry_type?: StopOrderExpiryType;
  new_trigger_price?: string;
  new_order_price?: string;
  new_trigger_type?: StopOrderTriggerType;
}
